import { useBienContext } from '../BienContext'

import { Input, Toggle } from '@/components/ui'
import DetailTemplate from '@/components/DetailTemplate'
import EditButtons from '../EditButtons'
import { formatDate } from '@/utils/formatters'
import Form from './Form'

export default () => {
  const { bien, 
    updatedSections, markSectionAsUpdated, 
    isPendingAction, closeModalCallback
  } = useBienContext()

  const SECTION_ID = 'assurances'
  const SECTION_TITLE = "Assurances"

  const modalContent = <Form title={SECTION_TITLE} />
  
  const editButton = <EditButtons
    bienId={bien.id}
    isArchived={!!bien.archived_at}
    isPendingAction={isPendingAction}
    title="Modifier les assurances"
  /> 

  return(
    <DetailTemplate
      title={SECTION_TITLE}
      sectionId={SECTION_ID}
      bodyProps={{columns: 3}}
      updatedSections={updatedSections}
      loading={false}
      isPendingAction={isPendingAction}
      editButton={editButton}
      modalContent={modalContent}
      onUpdateSuccess={markSectionAsUpdated}
      onCloseModalCallback={closeModalCallback}
    >
      <div className="space-y-4">
        { bien.immeuble_id ? <div className="min-h-3"></div> :
          <Toggle.Display label="Assurance propriétaire" value={bien.assurance_proprietaire} />
        }
        { bien.type_bien !== "immeuble" && <Toggle.Display label="Assurance locataire" value={bien.assurance_locataire} /> }
      </div>
      <div className="space-y-5 col-span-2">
         { bien.immeuble_id ? <div className="min-h-3"></div> :
           <>
             <Input.Display label="Date du dernier relevé d'assurance propriétaire" value={formatDate(bien.assurance_proprietaire_date_dernier_releve)} />
             <Input.Display label="Date d'échéance d'assurance propriétaire" value={formatDate(bien.assurance_proprietaire_date_echeance)} />
           </>
         }
         { bien.type_bien !== "immeuble" && (
           <>
             <Input.Display label="Date du dernier relevé d'assurance locataire" value={formatDate(bien.assurance_locataire_date_dernier_releve)} />
             <Input.Display label="Date d'échéance d'assurance locataire" value={formatDate(bien.assurance_locataire_date_echeance)} />
           </>
         )}
       </div>

    </DetailTemplate>
  )
}